const T = require('prop-types');

exports.RolePermissions = T.shape({
    id: T.number,
    roleId: T.number,
    schoolId: T.number,
    homeText: T.string,
    canEditAge: T.bool,
    canEditMajor: T.bool,
    canEditHomeTown: T.bool,
    canEditCareerAspiration: T.bool,
    canEditProfession: T.bool,
    canEditDepartment: T.bool,
    canEditBadge: T.bool,
    canEditTitle: T.bool,
    canEditIncomingClass: T.bool,
    canEditGraduatingClass: T.bool,
    canEditBio: T.bool,
    canEditLiveOnCampus: T.bool,
    canEditTransfer: T.bool,
    canEditVeteran: T.bool,
    canEditOnline: T.bool,
    canEditParent: T.bool,
    canEditOpenSocial: T.bool,
    canEditTimeStatus: T.bool,
    canEditStudentName: T.bool,
    canEditStudentBio: T.bool,
    canViewMajor: T.bool,
    canViewHomeTown: T.bool,
    canViewCareerAspiration: T.bool,
    canViewProfession: T.bool,
    canViewDepartment: T.bool,
    canViewBadge: T.bool,
    canViewTitle: T.bool,
    canViewIncomingClass: T.bool,
    canViewGraduatingClass: T.bool,
    canViewBio: T.bool,
    canViewLiveOnCampus: T.bool,
    canViewTransfer: T.bool,
    canViewVeteran: T.bool,
    canViewOnline: T.bool,
    canViewParent: T.bool,
    canViewOpenSocial: T.bool,
    canViewTimeStatus: T.bool,
    canViewStudentName: T.bool,
    canViewStudentBio: T.bool,
    canNotify: T.bool,
    canBatchNotify: T.bool,
    canPreapprove: T.bool,
    canCreateSurveys: T.bool,
    canDisable: T.bool,
    canCreateGroups: T.bool,
    canEditGroups: T.bool,
    canManageGroups: T.bool,
    canPlaceInModeration: T.bool
});
